









import { Vue, Component } from "vue-property-decorator"
import MfaEnrollmentAlert from "./components/MfaEnrollmentAlert/index.vue"

@Component({
  components: { MfaEnrollmentAlert }
})
class PostLoginAlertStack extends Vue {}

export default PostLoginAlertStack
